<template>
  <div class="charts-wrapper">
    <slot />
  </div>
</template>

<style lang="scss">
.charts-wrapper {
  margin-top: 64px;
  background-color: #fff;
  border: 1px solid #e4e6ea;
  width: 100%;
  min-height: calc(100vh - 445px);
}
</style>
